import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GridSelectionService {
  clearSelectAll$ = new Subject<void>();
}